/** Percent of the model NOT resident in VRAM (offloaded to CPU/RAM). 0 when it fully fits. */
export function spilloverPct(vramMb: number, sizeMb: number): number {
  if (sizeMb <= 0 || vramMb >= sizeMb) return 0;
  return Math.round(((sizeMb - vramMb) / sizeMb) * 100);
}

/** Human countdown to keep-alive expiry (e.g. "4m 12s"); null if unknown or already past. */
export function keepAliveCountdown(expiresAt: string | null, nowMs: number): string | null {
  if (!expiresAt) return null;
  const t = Date.parse(expiresAt);
  if (Number.isNaN(t)) return null;
  const remainingS = Math.floor((t - nowMs) / 1000);
  if (remainingS <= 0) return null;
  const m = Math.floor(remainingS / 60);
  const s = remainingS % 60;
  return `${m}m ${s}s`;
}
